var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 2H2.8C2.3584 2 2 2.3584 2 2.8V16.4C2 16.8416 2.3584 17.2 2.8 17.2H16.4C16.8416 17.2 17.2 16.8416 17.2 16.4V2.8C17.2 2.3584 16.8416 2 16.4 2ZM15.6 15.6H3.6V3.6H15.6V15.6Z",
    fill: "#303238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 18.4004V20.4004H18.4004V22.0004H21.2004C21.642 22.0004 22.0004 21.642 22.0004 21.2004V18.4004H20.4004Z",
    fill: "#303238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.552 20.4004H12.248V22.0004H16.552V20.4004Z",
    fill: "#303238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3998 20.4004V18.4004H6.7998V21.2004C6.7998 21.642 7.1582 22.0004 7.5998 22.0004H10.3998V20.4004H8.3998Z",
    fill: "#303238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2004 6.80078H18.4004V8.40078H20.4004V10.4008H22.0004V7.60078C22.0004 7.15918 21.642 6.80078 21.2004 6.80078Z",
    fill: "#303238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0004 12.248H20.4004V16.552H22.0004V12.248Z",
    fill: "#303238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.1b68b7e528b8abd716da007041788c03.svg";
export { ForwardRef as ReactComponent };